<template lang="pug">
  .welcome
    h1 Tonypedia
    h6 Encyclopedia of Thaksin Shinawatra
    .input-box
      b-autocomplete(v-model='name', :data='data', placeholder='Enter keyword', field='name',
        :loading='isFetching', @input='getAsyncData', @select="onSelect")
        template(slot-scope='props')
          | {{ props.option.name }}
    .links
      router-link(to="/person") Person
      router-link(to="/organization") Orginazation
      router-link(to="/event") Event
      router-link(to="/project") Project
    .sign-out
      span Welcome {{ $store.state.auth.user.email }} | {{ ' ' }}
      a(@click="onLogout") logout
</template>

<script>
import debounce from 'lodash/debounce'
import Node from '@/models/node'
export default {
  data () {
    return {
      data: [],
      name: '',
      selected: null,
      isFetching: false
    }
  },
  methods: {
    // You have to install and import debounce to use it,
    // it's not mandatory though.
    getAsyncData: debounce(function () {
      this.data = []
      this.isFetching = true
      Node.autocomplete(this.name)
        .then((models) => {
          this.isFetching = false
          this.data = models
        })
        .catch((error) => {
          this.isFetching = false
          throw error
        })
    }, 500),
    onSelect (option) {
      if (option) {
        this.$router.push({ name: `${option.labels[0].toLowerCase()}-detail`, params: { id: option._id } })
      }
    },
    onLogout () {
      this.$store.dispatch('auth/signout')
      this.$router.push({ path: '/signin' })
    }
  }
}
</script>
<style lang="scss">
.welcome {
  .autocomplete {
    .input {
      border: none;
      border-radius: 0;
      background-color: rgba(255, 255, 255, 0.5);
    }
  }
}
</style>
<style lang="scss" scoped>
.welcome {
  position: relative;
  background: black url('../../../static/images/bg.png') no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh);
  text-align: center;
  color: black;
  h1 {
    font-size: 60px;
    font-weight: bold;
    margin-bottom: 0px;
  }
  h6 {
    font-size: 24px;
    margin-bottom: 20px;
  }
  .input-box {
    margin-bottom: 20px;
    width: 80%;
    max-width: 500px;
    .input {
      border: none;
      border-radius: 0;
      background-color: rgba(255, 255, 255, 0.5);
    }
  }
  .btt {
    .button {
      border: none;
      border-radius: 0;
      background-color: rgba(255, 255, 255, 0.9);
      .fa {
        margin-right: 10px;
      }
    }
  }
  .links a{
    color: #ddd;
    margin: 0 5px;
  }
  .sign-out {
    position: absolute;
    top: 10px;
    right: 10px;
    color: white;
    a {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Index.vue